module.exports = __webpack_public_path__ + "static/ballisticArts-logo-edf2994fbdfd63b139aeda355ed4440c.jpeg";